import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-business-ebit-calculator',
  templateUrl: './business-ebit-calculator.component.html',
  styleUrls: ['./business-ebit-calculator.component.css']
})
export class BusinessEbitCalculatorComponent implements OnInit {
  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    value3: new FormControl(''),
    value4: new FormControl(''),
    value5: new FormControl(''),
    } )

  } 
  ebitda(n1,n2,n3,n4){
    var ebitdaV = n2+n3+n4;
    var ebitdaVa=n1-ebitdaV;
    var ebitdaVasimple= ebitdaVa.toFixed(2);
    return ebitdaVasimple ;
    }
    ebit(n1,n2,n3,n4,n5){
    var ebitVal=n1-(n2+n3+n4+n5);
    var ebitValSimple= ebitVal.toFixed(2);
    return ebitValSimple ; 
    }
 
}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/business-ebit-calculator/business-ebit-calculator.component.ts